var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7277 3.46248C10.5662 3.24048 10.3937 3.03295 10.2155 2.8399C10.0096 2.61307 9.61989 2.59376 9.3861 2.79647L7.7161 4.24431C7.83857 4.56284 7.86084 4.92963 7.7495 5.3109C7.55467 5.9914 6.92007 6.54158 6.13518 6.7105C5.69541 6.80702 5.27235 6.78772 4.90495 6.68154C4.90495 6.68154 4.10893 7.37169 3.53556 7.86879C3.25723 8.1101 3.3463 8.53481 3.71926 8.66029C4.31489 8.85816 4.93278 8.95951 5.56738 8.95951C6.55824 8.95951 7.52127 8.70855 8.4008 8.24041C9.29703 7.75779 10.1042 7.04834 10.7555 6.14583C11.2843 5.41708 11.2565 4.19122 10.7277 3.46248Z",
    fill: "#7E8C98"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69112 3.84974L4.44221 5.79952C4.15831 5.54855 3.97461 5.20107 3.97461 4.82462C3.97461 4.06691 4.68713 3.44434 5.56666 3.44434C6.00086 3.44434 6.40165 3.6036 6.69112 3.84974Z",
    fill: "#7E8C98"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04579 1.80767L7.1587 3.44375C6.75234 3.08661 6.1901 2.87426 5.56664 2.87426C4.31971 2.87426 3.31772 3.7478 3.31772 4.82405C3.31772 5.36459 3.56822 5.85204 3.97458 6.20435L2.09306 7.84044H2.08749C1.46959 7.40608 0.901796 6.85106 0.417498 6.1947C-0.139166 5.43698 -0.139166 4.2063 0.417498 3.44858C1.06323 2.57021 1.85369 1.88006 2.73322 1.40709C3.61275 0.943777 4.57578 0.687988 5.56664 0.687988C6.808 0.687988 8.0104 1.08374 9.04579 1.80767Z",
    fill: "#7E8C98"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15837 4.82326C7.15837 5.58097 6.44584 6.20355 5.56631 6.20355C5.53291 6.20355 5.50508 6.20355 5.47168 6.1939L7.14724 4.74121C7.15837 4.77017 7.15837 4.7943 7.15837 4.82326Z",
    fill: "#7E8C98"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0054 0.10859C10.8384 -0.0361966 10.5656 -0.0361966 10.3986 0.10859L0.128179 9.01777C-0.0388201 9.16255 -0.0388201 9.39904 0.128179 9.54382C0.211679 9.61139 0.317445 9.65 0.428778 9.65C0.54011 9.65 0.645877 9.61139 0.729376 9.539L11.0054 0.62982C11.178 0.485034 11.178 0.253376 11.0054 0.10859Z",
    fill: "#7E8C98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeCloseIcon);
export default __webpack_public_path__ + "static/media/eye-close-icon.e399a17f8b1b23eb2f85b2c3801d2d63.svg";
export { ForwardRef as ReactComponent };